import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "bridge-monitoring"
  }, [_c(VRow, {
    staticClass: "mb-4"
  }, [_c(VCol, {
    staticClass: "mb-0",
    attrs: {
      "cols": "12",
      "md": "8"
    }
  }, [_c('h3', [_vm._v(_vm._s(_vm.$i18n_t('Connectors.Monitoring.charts.title')))]), _c('p', {
    staticClass: "text--secondary text-caption mb-0"
  }, [_vm._v("\n        " + _vm._s(_vm.formatTimeRange(_vm.timeRange.from, _vm.timeRange.to)) + "\n      ")])]), _c(VCol, {
    staticClass: "mb-0",
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('div', {
    staticClass: "d-flex align-center justify-end"
  }, [_c(VSelect, {
    staticStyle: {
      "max-width": "240px"
    },
    attrs: {
      "items": _vm.timeFrames,
      "item-text": "name",
      "return-object": "",
      "solo": "",
      "dense": "",
      "hide-details": ""
    },
    on: {
      "change": _vm.handleTimeFrameChange
    },
    model: {
      value: _vm.selectedTimeFrame,
      callback: function ($$v) {
        _vm.selectedTimeFrame = $$v;
      },
      expression: "selectedTimeFrame"
    }
  }), _c(VBtn, {
    class: `ml-2 ${_vm.color}--text`,
    attrs: {
      "title": _vm.$i18n_t('Common.update'),
      "icon": "",
      "small": ""
    },
    on: {
      "click": _vm.refreshCharts
    }
  }, [_c(VIcon, {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v("fal fa-sync-alt")])], 1)], 1)])], 1), _c('bridge-monitoring-charts', {
    ref: "charts",
    attrs: {
      "bridge-id": _vm.bridgeId,
      "tenant-id": _vm.tenantId,
      "time-range": _vm.timeRange
    }
  }), _c(VDivider, {
    staticClass: "my-8"
  }), _c('bridge-monitoring-rules', {
    attrs: {
      "bridge-id": _vm.bridgeId,
      "monitoring-config-id": _vm.monitoringConfig.id,
      "monitoring-config": _vm.monitoringConfig,
      "tenant-id": _vm.tenantId
    },
    on: {
      "rule-updated": function ($event) {
        return _vm.$emit('config-changed');
      }
    }
  }), _c(VDivider, {
    staticClass: "my-8"
  }), _c(VRow, [_c(VCol, [_c('h3', [_vm._v(_vm._s(_vm.$i18n_t('Connectors.Monitoring.settings.title')))])])], 1), _c(VRow, [_c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c(VExpansionPanels, {
    attrs: {
      "value": null,
      "flat": ""
    }
  }, [_c(VExpansionPanel, [_c(VExpansionPanelHeader, {
    staticClass: "px-0"
  }, [_c('span', {
    staticClass: "text--secondary"
  }, [_vm._v(_vm._s(_vm.$i18n_t('Connectors.Monitoring.settings.description')))])]), _c(VExpansionPanelContent, {
    staticClass: "px-0"
  }, [_c(VRow, [_c(VCol, {
    attrs: {
      "cols": "12",
      "md": "6",
      "lg": "4"
    }
  }, [_c(VCard, {
    attrs: {
      "outlined": ""
    }
  }, [_c(VCardText, [_c('div', {
    staticClass: "mb-2 font-weight-medium"
  }, [_vm._v("\n                      " + _vm._s(_vm.$i18n_t('Connectors.Monitoring.settings.evaluationInterval.label')) + "\n                    ")]), _c('p', {
    staticClass: "text--secondary text-caption mb-4"
  }, [_vm._v("\n                      " + _vm._s(_vm.$i18n_t('Connectors.Monitoring.settings.evaluationInterval.description')) + "\n                    ")]), _c(VSelect, {
    attrs: {
      "items": _vm.evaluationIntervalOptions,
      "label": _vm.$i18n_t('Connectors.Monitoring.settings.evaluationInterval.label'),
      "outlined": "",
      "dense": "",
      "hide-details": "",
      "suffix": "min"
    },
    on: {
      "change": _vm.updateEvaluationInterval
    },
    model: {
      value: _vm.evaluationIntervalMinutes,
      callback: function ($$v) {
        _vm.evaluationIntervalMinutes = $$v;
      },
      expression: "evaluationIntervalMinutes"
    }
  })], 1)], 1)], 1), _c(VCol, {
    attrs: {
      "cols": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c(VCard, {
    attrs: {
      "outlined": ""
    }
  }, [_c(VCardText, [_c('div', {
    staticClass: "d-flex justify-space-between align-center mb-2"
  }, [_c('div', {
    staticClass: "font-weight-medium"
  }, [_vm._v("\n                        " + _vm._s(_vm.$i18n_t('Connectors.Monitoring.settings.emailNotifications.label')) + "\n                      ")]), _vm.emailConnectors.length > 0 ? _c(VChip, {
    attrs: {
      "x-small": "",
      "color": "primary",
      "outlined": ""
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.emailConnectors.length) + " available\n                      ")]) : _vm._e()], 1), _c('p', {
    staticClass: "text--secondary text-caption mb-4"
  }, [_vm._v("\n                      " + _vm._s(_vm.$i18n_t('Connectors.Monitoring.settings.emailNotifications.description')) + "\n                    ")]), _c(VSelect, {
    staticClass: "mb-3",
    attrs: {
      "items": _vm.emailConnectors,
      "label": _vm.$i18n_t('Connectors.Monitoring.settings.emailNotifications.connector'),
      "hint": _vm.emailConnectors.length === 0 ? 'No SMTP connectors available' : '',
      "persistent-hint": _vm.emailConnectors.length === 0,
      "item-text": "name",
      "item-value": "id",
      "item-disabled": "disabled",
      "outlined": "",
      "dense": "",
      "clearable": ""
    },
    scopedSlots: _vm._u([{
      key: "no-data",
      fn: function () {
        return [_c(VListItem, [_c(VListItemContent, [_c(VListItemTitle, [_vm._v("No SMTP connectors found")]), _c(VListItemSubtitle, [_vm._v("Create a bridge-mail connector first")])], 1)], 1)];
      },
      proxy: true
    }]),
    model: {
      value: _vm.emailSettings.connectorId,
      callback: function ($$v) {
        _vm.$set(_vm.emailSettings, "connectorId", $$v);
      },
      expression: "emailSettings.connectorId"
    }
  }), _c(VTextField, {
    staticClass: "mb-3",
    attrs: {
      "label": _vm.$i18n_t('Connectors.Monitoring.settings.emailNotifications.senderEmail'),
      "disabled": !_vm.emailSettings.connectorId,
      "outlined": "",
      "dense": "",
      "type": "email",
      "placeholder": "noreply@example.com"
    },
    model: {
      value: _vm.emailSettings.senderEmail,
      callback: function ($$v) {
        _vm.$set(_vm.emailSettings, "senderEmail", $$v);
      },
      expression: "emailSettings.senderEmail"
    }
  }), _c(VTextField, {
    staticClass: "mb-4",
    attrs: {
      "label": _vm.$i18n_t('Connectors.Monitoring.settings.emailNotifications.recipientEmail'),
      "disabled": !_vm.emailSettings.connectorId,
      "outlined": "",
      "dense": "",
      "type": "email",
      "placeholder": "alerts@example.com"
    },
    model: {
      value: _vm.emailSettings.recipientEmail,
      callback: function ($$v) {
        _vm.$set(_vm.emailSettings, "recipientEmail", $$v);
      },
      expression: "emailSettings.recipientEmail"
    }
  }), _c('div', {
    staticClass: "d-flex justify-end"
  }, [_c('core-button', {
    attrs: {
      "color": _vm.color,
      "disabled": !_vm.emailSettings.connectorId || _vm.savingEmail,
      "loading": _vm.savingEmail,
      "prepend-icon": "fa-save"
    },
    on: {
      "click": _vm.saveEmailSettings
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.$i18n_t('Common.save')) + "\n                      ")])], 1)], 1)], 1)], 1), false ? _c(VCol, {
    attrs: {
      "cols": "12",
      "md": "6",
      "lg": "6"
    }
  }, [_c(VCard, {
    attrs: {
      "outlined": ""
    }
  }, [_c(VCardText, [_c('div', {
    staticClass: "d-flex justify-space-between align-center mb-2"
  }, [_c('div', {
    staticClass: "font-weight-medium"
  }, [_vm._v("\n                        " + _vm._s(_vm.$i18n_t('Connectors.Monitoring.settings.webhookNotifications.label')) + "\n                      ")]), _vm.webhookConnectors.length > 0 ? _c(VChip, {
    attrs: {
      "x-small": "",
      "color": "primary",
      "outlined": ""
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.webhookConnectors.length) + " available\n                      ")]) : _vm._e()], 1), _c('p', {
    staticClass: "text--secondary text-caption mb-4"
  }, [_vm._v("\n                      " + _vm._s(_vm.$i18n_t('Connectors.Monitoring.settings.webhookNotifications.description')) + "\n                    ")]), _c(VSelect, {
    staticClass: "mb-3",
    attrs: {
      "items": _vm.webhookConnectors,
      "label": _vm.$i18n_t('Connectors.Monitoring.settings.webhookNotifications.connector'),
      "hint": _vm.webhookConnectors.length === 0 ? 'No webhook connectors available' : '',
      "persistent-hint": _vm.webhookConnectors.length === 0,
      "item-text": "name",
      "item-value": "id",
      "item-disabled": "disabled",
      "outlined": "",
      "dense": "",
      "clearable": ""
    },
    scopedSlots: _vm._u([{
      key: "no-data",
      fn: function () {
        return [_c(VListItem, [_c(VListItemContent, [_c(VListItemTitle, [_vm._v("No webhook connectors found")]), _c(VListItemSubtitle, [_vm._v("Create a bridge-webhook connector first")])], 1)], 1)];
      },
      proxy: true
    }], null, false, 1948301388),
    model: {
      value: _vm.webhookSettings.connectorId,
      callback: function ($$v) {
        _vm.$set(_vm.webhookSettings, "connectorId", $$v);
      },
      expression: "webhookSettings.connectorId"
    }
  }), _c(VSelect, {
    staticClass: "mb-3",
    attrs: {
      "items": _vm.webhookFormatOptions,
      "label": _vm.$i18n_t('Connectors.Monitoring.settings.webhookNotifications.format'),
      "disabled": !_vm.webhookSettings.connectorId,
      "outlined": "",
      "dense": "",
      "hide-details": ""
    },
    scopedSlots: _vm._u([{
      key: "prepend-inner",
      fn: function () {
        return [_c(VIcon, {
          staticClass: "mr-1",
          attrs: {
            "small": ""
          }
        }, [_vm._v("fal fa-code")])];
      },
      proxy: true
    }], null, false, 2037395117),
    model: {
      value: _vm.webhookSettings.format,
      callback: function ($$v) {
        _vm.$set(_vm.webhookSettings, "format", $$v);
      },
      expression: "webhookSettings.format"
    }
  }), _c('div', {
    staticClass: "mb-4",
    staticStyle: {
      "height": "92px"
    }
  }), _c('div', {
    staticClass: "d-flex justify-end"
  }, [_c('core-button', {
    attrs: {
      "color": _vm.color,
      "disabled": !_vm.webhookSettings.connectorId || _vm.savingWebhook,
      "loading": _vm.savingWebhook,
      "prepend-icon": "fa-save"
    },
    on: {
      "click": _vm.saveWebhookSettings
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.$i18n_t('Common.save')) + "\n                      ")])], 1)], 1)], 1)], 1) : _vm._e()], 1)], 1)], 1)], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };